export default __webpack_public_path__ + "static/media/ttg-icon.e826d748.svg";